import { render, staticRenderFns } from "./CoverRow.vue?vue&type=template&id=46c6acd8&scoped=true"
import script from "./CoverRow.vue?vue&type=script&lang=js"
export * from "./CoverRow.vue?vue&type=script&lang=js"
import style0 from "./CoverRow.vue?vue&type=style&index=0&id=46c6acd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c6acd8",
  null
  
)

export default component.exports